import {
  Component,
  ElementRef,
  HostListener,
  Input,
  inject,
} from "@angular/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BEBasicService } from "@services/be-basic.service";
import { BeUsersService } from "@services/business/user-services/be-users.service";
import { ButtonComponent } from "@ui/controls/button/button.component";
import { NotificationModalComponent } from "@ui/controls/modals/notification-modal/notification-modal.component";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";

@Component({
  selector: "profile-user-button",
  templateUrl: "./user-button.component.html",
  styleUrl: "./user-button.component.scss",
  imports: [
    TranslateModule,
    MatDialogModule,
    IconDisplayComponent,
    ButtonComponent,
  ],
})
export class UserButtonComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private elementRef = inject(ElementRef);
  private usersService = inject(BeUsersService);
  private translateService = inject(TranslateService);
  private apiServices = inject(BEBasicService);

  @Input() public firstName = "";
  @Input() public lastName = "";

  protected isMenuOpen = false;

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.isMenuOpen &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.closeMenu();
    }
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  goToSettings(): void {
    const { isReviewer } = this.usersService.getRoleFlags();
    if (!isReviewer) {
      this.router.navigate(["/profile"]);
    } else {
      this.router.navigate(["/dashboard/management/configuration"]);
    }
    this.closeMenu();
  }

  logout(): void {
    this.dialog
      .open(NotificationModalComponent, {
        data: {
          description: this.translateService.instant(
            "LogoutComponent.ConfirmMessage"
          ),
          primaryButtonText: this.translateService.instant(
            "LogoutComponent.Logout"
          ),
          secondaryButtonText: this.translateService.instant("App.Cancel"),
          iconName: "logout-modal",
          type: "error",
          showCloseButton: true,
        },
        panelClass: "notification-modal-panel",
      })
      .afterClosed()
      .subscribe(result => {
        if (result === true) {
          this.apiServices.logOut(() => {
            this.router.navigate(["login"]);
          });
        }
      });
    this.closeMenu();
  }
}
